import Vue from 'vue';
import Vuex from 'vuex';

// Module imports
import { alert } from './modules/alert.module';
import { adminuser } from './modules/adminuser.module';
import { organizations } from './modules/organizations.module';
import { users } from './modules/users.module';
import { digiboards } from './modules/digiboards.module';
import { support } from './modules/support.module';
import { accountcontrol } from './modules/accountcontrol.module';
import { payments } from './modules/payments.module';
import { settings } from './modules/settings.module';
import { widgets } from './modules/widgets.module';
import { partners } from './modules/partners.module';
import { digitalmarketing } from './modules/digitalmarketing.module';
import { blogs } from './modules/blogs.module';
import { knowledgebase } from './modules/knowledgebase.module'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: require('@/assets/sidebar-3.jpg'),
    drawer: null,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload;
    },
  },
  actions: {},
  getters: {},
  modules: {
    alert,
    adminuser,
    organizations,
    users,
    digiboards,
    support,
    accountcontrol,
    payments,
    settings,
    widgets,
    partners,
    digitalmarketing,
    knowledgebase,
    blogs,
    knowledgebase,
  },
});
